import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
//import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
//import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {FormControl} from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import {Location} from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';
//declare function setProgress(percentual, masc) :any;
// import * as _moment from 'moment';
// // tslint:disable-next-line:no-duplicate-imports
// import {Moment} from 'moment';

// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'MM/YYYY',
//   },
//   display: {
//     dateInput: 'MM/YYYY',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };
// const moment = _moment;

@Component({
  selector: 'app-dashboard-aderencia',
  templateUrl: './dashboard-aderencia.component.html',
  styleUrls: ['./dashboard-aderencia.component.css'],
  providers:[
    // {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    // {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class DashboardAderenciaComponent implements OnInit, OnDestroy {
  hideLoginLoad: boolean = false;
  idPaciente: any = '';
  idPlano: any = 0;
  //tipoPlano: any = '';
  periodoC: boolean = true;
  dataFiltrar: any = '';

  view: any[] = [400, 300];
  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  // showXAxisLabel = true;
  // xAxisLabel = 'Composição Corporal';
  //showYAxisLabel = true;
  //yAxisLabel = 'Peso';
  //timeline = true;

    // options
    legend: boolean = true;
    showLabels: boolean = true;
    animations: boolean = true;
    xAxis: boolean = true;
    yAxis: boolean = true;
    showYAxisLabel: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Período';
    yAxisLabel: string = 'Número Refeições';
    timeline: boolean = true;
    dataplano: any = '';
    datahj: any = '';
    contadorDP: any = 0;
  colorScheme = {
    domain: ['#FF7F50', '#2ade89','#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };
  colorScheme2 = {
    domain: ['#2ade89','#FF7F50']
  };
  //pie
  //showLabels = true;
  // data goes here
  public single = [];
  public multi = [];
  public grAdereDia = [];
  public aproveitamento = [];
  arrAderencia: any[] = [];
  arrAderenciaSem: any[] = [];
  arrPeriodo: any[] = [];
  //date = new FormControl(moment());
  diasSemana = ['Domingo', 'Segunda-Feira', 'Terça-Feira','Quarta-Feira','Quinta-Feira','Sexta-Feira','Sábado'];

  startView: string = "multi-year"
  dataPicked: Date;
  botaoGerar: boolean = false;
  periodoAdere: any = '';
  designatedTotal: any = 0;
  periodoAdereF: any = '';
  constructor(private route: ActivatedRoute, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location) { }
  

  // chosenYearHandler(normalizedYear: Moment) {
  //   this.botaoGerar = false;
  //   const ctrlValue = this.date.value;
  //     ctrlValue.year(normalizedYear.year());
  //     this.date.setValue(ctrlValue);

  //   var qMom = _moment(this.dataplano);
  //   console.log(normalizedYear);
  //   console.log(qMom.diff(normalizedYear, 'year', false));

  // }

  // chosenMonthHandler(normlizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
  //   console.log(this.date.value);
  
  //   if(this.date.status == "INVALID"){
    
  //   }
  //   else{
  //     const ctrlValue = this.date.value;
  //     ctrlValue.month(normlizedMonth.month());
  //     this.date.setValue(ctrlValue);
  //     console.log("validada na força!");
  //     datepicker.close();
  //   }
  // }


  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.hideLoginLoad = false;
    this.idPaciente = this.route.snapshot.paramMap.get('idpaciente');
    //this.tipoPlano = this.route.snapshot.paramMap.get('tipoplano');
    this.idPlano = this.route.snapshot.paramMap.get('idplano');
    this.dataFiltrar = "01/01/01";
    this.periodoC = true;
    
    this.carregarAderencia();
    //var dataTeste = _moment("01/10/2019").format("DD/MM/YYYY");
    // this.datahj = new Date();
    // this.dataplano = new Date(dataTeste);
    // this.dataPicked = this.datahj;
    //console.log(dataTeste);
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }


  // dataSelecionada() :void{
  //   console.log("foi");
  //   console.log(this.date);
  //   if(this.date.status == "VALID"){
  //     console.log("tá valido");
  //     console.log(this.date);
  //     this.botaoGerar = true;
  //   }
  //   else{
     
  //   }
  // }

  // hideBT() :void{
  //   this.botaoGerar = false;
  //   this.contadorDP = 0;
  // }






  carregarAderencia() :void{

    var dataBuscar = "";
    if(this.periodoAdere == ''){
      dataBuscar = this.dataFiltrar;
      this.periodoC = true;
    }
    else{
      dataBuscar = this.periodoAdere;
      if(this.periodoAdere != this.dataFiltrar){
        this.periodoC = false;
      }
      else{
        this.periodoC = true;
      }
    }
    this.hideLoginLoad = false;
    var dadosF = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente + '&idplano=' + this.idPlano + '&mesatual=' + this.periodoC + '&dataescolhida=' + dataBuscar
    this.tmaService.getAderenciaAli(dadosF).subscribe((qRes) =>{
      console.log(qRes);
      if(qRes['res'] == 'ok'){
        this.hideLoginLoad = true;
        //this.multi = qRes['objDatas'];
        this.arrAderencia = qRes['objDatas'];
        this.arrAderenciaSem = qRes['objSemana'];
        if(this.periodoC){
          this.arrPeriodo = qRes['objPeriodo'];
        }
        this.periodoAdere = qRes['periodoA'];
        this.periodoAdereF = this.periodoAdere.split("/")[1] + "/" + this.periodoAdere.split("/")[2];
        this.botaoGerar = false;
        var refeicoesD = [];
        var refeicoesR = [];
   
        var arr_Seg= [];
        var arr_Ter = [];
        var arr_Qua = []; var arr_Qui = [];var arr_Sex =[];var arr_Sab=[]; var arr_Dom = [];

        this.arrAderencia.forEach((element, idx) => {
          refeicoesD.push({name: element.dia, value: element.qtdDone });
          refeicoesR.push({name: element.dia, value: element.qtdRef });
        });
        this.designatedTotal = qRes['refeicoesTotal'];
        this.aproveitamento = [{ name: "Realizadas", value: qRes['refeicoesDone']}, { name: "Prescritas", value: qRes['refeicoesTotal']}];
        //this.aproveitamento = [{ name: "Prescritas", value: qRes['refeicoesTotal']}, { name: "Realizadas", value: qRes['refeicoesDone']}];
        
        this.arrAderenciaSem.forEach(element => {
          if(element.ds == 0){
            arr_Dom.push({name: "Prescritas", value: element.qtdRef} , {name: "Realizadas", value: element.qtdDone });
          }
          if(element.ds == 1){
            arr_Seg.push({name: "Prescritas", value: element.qtdRef} , {name: "Realizadas", value: element.qtdDone });
          }
          if(element.ds == 2){
            arr_Ter.push({name: "Prescritas", value: element.qtdRef} , {name: "Realizadas", value: element.qtdDone });
          }
          if(element.ds == 3){
            arr_Qua.push({name: "Prescritas", value: element.qtdRef} , {name: "Realizadas", value: element.qtdDone });
          }
          if(element.ds == 4){
            arr_Qui.push({name: "Prescritas", value: element.qtdRef} , {name: "Realizadas", value: element.qtdDone });
          }
          if(element.ds == 5){
            arr_Sex.push({name: "Prescritas", value: element.qtdRef} , {name: "Realizadas", value: element.qtdDone });
          }
          if(element.ds == 6){
            arr_Sab.push({name: "Prescritas", value: element.qtdRef} , {name: "Realizadas", value: element.qtdDone });
          }
        });
       setTimeout(() => {
        //this.multi.push({ name: "Realizado", series: refeicoesD}, {name: "Total", series: refeicoesR});
        this.multi = [{ name: "Prescritas", series: refeicoesR}, { name: "Realizadas" , series: refeicoesD}];
        this.grAdereDia = [{ name: "Segunda Feira", series: arr_Seg}, { name: "Terça Feira", series: arr_Ter },{ name: "Quarta Feira", series: arr_Qua },{ name: "Quinta Feira", series: arr_Qui },{ name: "Sexta Feira", series: arr_Sex },{ name: "Sábado", series: arr_Sab },{ name: "Domingo", series: arr_Dom }];
        //this.multi.push({ name: "Total", series: refeicoesR});
        console.log(this.multi);
        console.log(this.grAdereDia);
        //this.renderizarGrafico();
       }, 0);
      }
    });

  }

  pickPeriodo(qEvent: any) : void{
    console.log(qEvent);
    this.periodoAdere = qEvent.value;
    this.botaoGerar = true;
  }

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
  
  renderizarGrafico() :void{

  this.single = [
    {
      "name": "Germany",
      "series": [
        {
          "name": "1990",
          "value": 62000000
        },
        {
          "name": "2010",
          "value": 73000000
        },
        {
          "name": "2011",
          "value": 89400000
        }
      ]
    },
  
    {
      "name": "USA",
      "series": [
        {
          "name": "1990",
          "value": 250000000
        },
        {
          "name": "2010",
          "value": 309000000
        },
        {
          "name": "2011",
          "value": 311000000
        }
      ]
    },
  
    {
      "name": "France",
      "series": [
        {
          "name": "1990",
          "value": 58000000
        },
        {
          "name": "2010",
          "value": 50000020
        },
        {
          "name": "2011",
          "value": 58000000
        }
      ]
    },
    {
      "name": "UK",
      "series": [
        {
          "name": "1990",
          "value": 57000000
        },
        {
          "name": "2010",
          "value": 62000000
        }
      ]
    }
  ];

  console.log(this.single);


  }

    voltar(): void{
      //this._location.back();
      this.router.navigate(['/dashboard/paciente/' + this.idPaciente ]);
      
  }
}
